import { adminAPIService } from './index'

const route = 'edms'

export default {
  getRegularEdmList(params) {
    return adminAPIService({
      url: `${route}/regular`,
      method: 'get',
      params,
    })
  },
  getRegularEdmDetail(id) {
    return adminAPIService({
      url: `${route}/regular/${id}`,
      method: 'get',
    })
  },
  createRegularEdm(detail) {
    const formData = new FormData()
    formData.append('json', JSON.stringify(detail))
    
    return adminAPIService({
      url: `${route}/regular`,
      method: 'post',
      data: formData,
    })
  },
  updateRegularEdm(id, detail) {
    const formData = new FormData()
    formData.append('json', JSON.stringify(detail))
    
    return adminAPIService({
      url: `${route}/regular/${id}`,
      method: 'post',
      data: formData,
    })
  },
  deleteRegularEdm(id) {
    return adminAPIService({
      url: `${route}/regular/${id}`,
      method: 'delete',
    })
  },
  testRegularEdm(id) {
    return adminAPIService({
      url: `${route}/regular/${id}/test`,
      method: 'post',
    })
  },
  getTBREdmList(params) {
    return adminAPIService({
      url: `${route}/tbr`,
      method: 'get',
      params,
    })
  },
  getTBREdmDetail(id) {
    return adminAPIService({
      url: `${route}/tbr/${id}`,
      method: 'get',
    })
  },
  createTBREdm(detail) {
    const formData = new FormData()
    formData.append('json', JSON.stringify(detail))
    
    return adminAPIService({
      url: `${route}/tbr`,
      method: 'post',
      data: formData,
    })
  },
  updateTBREdm(id, detail) {
    const formData = new FormData()
    formData.append('json', JSON.stringify(detail))
    
    return adminAPIService({
      url: `${route}/tbr/${id}`,
      method: 'post',
      data: formData,
    })
  },
  deleteTBREdm(id) {
    return adminAPIService({
      url: `${route}/tbr/${id}`,
      method: 'delete',
    })
  },
  testTBREdm(id) {
    return adminAPIService({
      url: `${route}/tbr/${id}/test`,
      method: 'post',
    })
  },
}
